export const ticketIconsMap = [
  {
    id: 1,
    path: 'assets/img/icon-local-connect.svg',
    pathGrey: 'assets/img/icon-local-connect-grey.svg',
    name: 'Заявка на подключение',
  },
  {
    id: 2,
    path: 'assets/img/icon-dozakaz.svg',
    pathGrey: 'assets/img/icon-dozakaz-grey.svg',
    name: 'Дозаказ',
  },
  {
    id: 3,
    path: 'assets/img/icon-problem.svg',
    pathGrey: 'assets/img/icon-problem-grey.svg',
    name: 'Локальная проблема',
  },
  {
    id: 4,
    path: 'assets/img/icon-problem.svg',
    pathGrey: 'assets/img/icon-problem-grey.svg',
    name: 'Глобальная проблема',
  },
  {
    id: 5,
    path: 'assets/img/icon-contract.svg',
    pathGrey: 'assets/img/icon-contract-grey.svg',
    name: 'Исправление договора',
  },
  {
    id: 6,
    path: 'assets/img/icon-local-request.svg',
    pathGrey: 'assets/img/icon-local-request-grey.svg',
    name: 'Локальная заявка',
  },
  {
    id: 7,
    path: 'assets/img/icon-service-engineer.svg',
    pathGrey: 'assets/img/icon-services-engineer-grey.svg',
    name: 'Сервис-инженер',
  },
];
export const defaultTicketIcon = ticketIconsMap[5];
